module.exports = __webpack_public_path__ + "encs/web_store/avpv/img/woa-user.3998b825.svg";